import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { activityService } from '@/services/activity';
import useVuelidate from '@vuelidate/core';
import { minLength, numeric } from '@vuelidate/validators';

export function useActivity() {
    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            feature: { type: 'string', default: StringUtils.Characters.Empty },
            action: { type: 'number', default: 0 },
            accountId: { type: 'number', default: null },
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const validations = {
        feature: { min: minLength(3) },
        accountId: { numeric }
    };

    const v$ = useVuelidate(validations, query);

    const { list, total, fetchList } = useBaseListView({
        request: activityService.app.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            canFetch: () => {
                v$.value.$touch();
                return !v$.value.$invalid;
            },
            transformResponse: list =>
                list.map(item => ({
                    ...item,
                    accountName: `${item.firstname} ${item.lastname}`
                }))
        }
    });

    return { query, v$, list, total, fetchList };
}
